import { render, staticRenderFns } from "./clientRoles-add.vue?vue&type=template&id=be70c654&scoped=true"
import script from "./clientRoles-add.vue?vue&type=script&lang=js"
export * from "./clientRoles-add.vue?vue&type=script&lang=js"
import style0 from "./clientRoles-add.vue?vue&type=style&index=0&id=be70c654&lang=css"
import style1 from "./clientRoles-add.vue?vue&type=style&index=1&id=be70c654&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be70c654",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be70c654')) {
      api.createRecord('be70c654', component.options)
    } else {
      api.reload('be70c654', component.options)
    }
    module.hot.accept("./clientRoles-add.vue?vue&type=template&id=be70c654&scoped=true", function () {
      api.rerender('be70c654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/siteSetting/clientRoles-add.vue"
export default component.exports